import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.unmatch-match.presenters.UnmatchMatchPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to unmatch the transaction.',
  },
})
